export const footerTR = {
    "contactHours": "İletişim Saatleri",
    "week": "Pazartesi - Cuma",
    "contactUs": "Bize Ulaşın",
    "address": "131 Mesogeion cad. Marousi 15126",
    "findUs": "Haritada Bul",
    "contact": "İletişim",
    "privacyPolicy": "Gizlilik Politikası",
    "termsOfService": "Kullanım Şartları",
    "stayConnected": "Bağlı Kalın",
    "cookiesTitle": "Çerez Kullanımı",
    "aboutUs": "Hakkımızda",
    "cookiesText": "Yalnızca gerekli minimum çerezleri kullanıyoruz. Kişisel verileriniz hiçbirinde saklanmaz.",
    "cookiesAccept": "Kabul Et",
    "cookiesManagement": "Çerez Yönetimi",
    "cookiesManage": "Yönetim",
    "accessibilityTitle": "Erişilebilirlik",
    "fontIncrease": "Yazı boyutunu büyüt",
    "fontDecrease": "Yazı boyutunu küçült",
    "greyscale": "Gri tonlama",
    "highContrast": "Yüksek kontrast",
    "negativeContrast": "Negatif kontrast",
    "lightBackground": "Açık arka plan",
    "linksUnderline": "Bağlantıların altını çiz",
    "readableFont": "Okunabilir yazı tipi",
    "reset": "Sıfırla",
    "paymentOptions": "Ödeme Seçenekleri",
    "deliveryOptions": "Teslimat Seçenekleri",
    "openingTime": "Çalışma Saatleri",
    "loginRegister": "Giriş/Kayıt",
    "messagingTitle": "Destek",
    "messagingSubTitle": "Sorularınızı mesaj olarak gönderin!",
    "message": "Mesaj",
    "installBringFood": "BrigFood ile başlayın!",
    "usefull": "Faydalı",
    "company": "Şirket",
    "faq": "SSS",
    "chatPlaceholder": "Metin girin...",
    "restaurantClosed": "Mekan şu anda kapalı olduğundan siparişinizi hazırlayamıyoruz",
    "holidayText": "Mekan bugün kapalı olacaktır",
    "allDay": "Tüm gün",
    "to": "Kadar"
}